module.exports = __webpack_public_path__ + "media/Video 28.686640ca.mp4";